import React from 'react';
import SEO from '../../components/SEO';

import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../data/translations';

const AfterSalesService = () => {
    const { language } = useLanguage();
    const t = translations[language].afterSales;
    return (
        <div className="pt-24 lg:pt-[130px] pb-20 bg-white">
            <SEO
                title="BAIC After Sales Service Oman | Service Center Oman"
                description="Professional BAIC after-sales service in the Oman with genuine parts."
                canonicalUrl="https://baicoman.com/about/after-sales-service"
            />
            <h1 className="sr-only">BAIC After Sales Service Oman - Maintenance & Support</h1>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Main Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 auto-rows-[300px]">

                    {/* Integrity - Tall Column (Span 2 rows on desktop) */}
                    <div className="lg:row-span-2 group relative rounded-2xl overflow-hidden shadow-lg cursor-pointer">
                        <img
                            src="/assets/images/about/after-sales-service/integrity.png"
                            alt="Integrity"
                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex flex-col justify-end p-8">
                            <h3 className="text-3xl font-bold text-white mb-2">{t.integrity.title}</h3>
                            <p className="text-gray-200 text-sm leading-relaxed max-w-xs">
                                {t.integrity.desc}
                            </p>
                        </div>
                    </div>

                    {/* Warm */}
                    <div className="group relative rounded-2xl overflow-hidden shadow-lg cursor-pointer">
                        <img
                            src="/assets/images/about/after-sales-service/warm.png"
                            alt="Warm"
                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex flex-col justify-end p-6">
                            <h3 className="text-xl font-bold text-white mb-4">{t.warm.title}</h3>
                            <p className="text-gray-200 text-sm leading-relaxed">
                                {t.warm.desc}
                            </p>
                        </div>
                    </div>

                    {/* Care */}
                    <div className="group relative rounded-2xl overflow-hidden shadow-lg cursor-pointer">
                        <img
                            src="/assets/images/about/after-sales-service/care.png"
                            alt="Care"
                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex flex-col justify-end p-6">
                            <h3 className="text-2xl font-bold text-white mb-2">{t.care.title}</h3>
                            <p className="text-gray-200 text-sm leading-relaxed">
                                {t.care.desc}
                            </p>
                        </div>
                    </div>

                    {/* Professional - Full width of right column */}
                    <div className="lg:col-span-2 group relative rounded-2xl overflow-hidden shadow-lg cursor-pointer">
                        <img
                            src="/assets/images/about/after-sales-service/professional.png"
                            alt="Professional"
                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex flex-col justify-end p-8">
                            <h3 className="text-3xl font-bold text-white mb-2">{t.professional.title}</h3>
                            <p className="text-gray-200 text-sm leading-relaxed">
                                {t.professional.desc}
                            </p>
                        </div>
                    </div>

                </div>



            </div>
        </div>
    );
};

export default AfterSalesService;
